import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import "./PublishStatusModal.css";

function PublishStatusModal({
  show,
  type = "loading",
  environment = [],
  resultItems = [],
  onClose,
  title = "Publishing Information",
  loadingTitle = "Publishing Rule",
  successTitle = "Rule Published Successfully",
  loadingMessage = "Your rule is being published",
  successMessage = "Your rule has been successfully published",
  loadingInfoMessage = "Please do not close or refresh this page until publishing is complete.",
  failedTitle = "Rule Publishing Failed",
  failedMessage = "We couldn't complete the publishing of your rule.",
  failedInfoMessage = "Some items could not be published. Please try again.",
}) {
  if (!show) {
    return null;
  }

  const environmentDisplay =
    Array.isArray(environment) && environment.length > 0
      ? environment.join(", ")
      : "";

  const isPublishSuccess =
    resultItems?.length > 0 &&
    resultItems.every((item) => item?.status === "COMPLETED");

  const failedItems =
    resultItems?.filter((item) => item?.status === "FAILED") || [];

  return (
    <div className="publishedRule-modal-overlay">
      <div className="publishedRule-info-modal">
        {/* Header */}
        <div className="publishedRule-info-modal-header">
          <h3 className="publishedRule-info-modal-header-text">
            {type === "loading" ? loadingTitle : title}
          </h3>

          {type === "result" && (
            <button
              type="button"
              onClick={onClose}
              className="publishedRule-modal-close"
            >
              <CloseIcon />
            </button>
          )}
        </div>

        {/* Body */}
        <div className="publishedRule-info-modal-body">
          {type === "loading" && (
            <div className="publishedRule-loading-content">
              <div className="publishedRule-spinner" />

              <div className="publishRule-loader">
                <div className="publishRule-loader">
                  <svg viewBox="0 0 48 48">
                    <rect
                      x="3"
                      y="3"
                      width="42"
                      height="42"
                      rx="8"
                      fill="none"
                      stroke="#e0e0e0"
                      strokeWidth="3"
                    />

                    <rect
                      className="publishRule-loader-progress"
                      x="3"
                      y="3"
                      width="42"
                      height="42"
                      rx="8"
                      fill="none"
                      stroke="#1976d2"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />

                    <circle
                      cx="24"
                      cy="24"
                      r="3"
                      fill="#1976d2"
                    />
                  </svg>
                </div>
              </div>

              <h5>Please wait...</h5>

              <p>
                {loadingMessage}

                {environmentDisplay && (
                  <>
                    {" "}
                    <strong className="publishedRule-result-content-env">
                      {environmentDisplay}
                    </strong>
                  </>
                )}

                {!loadingMessage.endsWith(".") && "."} This may take a few
                moments.
              </p>

              <p className="publishedRule-result-content-loader-info">
                <InfoIcon color="inherit" sx={{ mr: 1 }} />
                {loadingInfoMessage}
              </p>
            </div>
          )}

          {type === "result" && (
            <div className="publishedRule-result-content">
              {isPublishSuccess ? (
                <>
                  <CheckCircleIcon
                    fontSize="large"
                    sx={{ color: "#059669" }}
                  />

                  <h5>{successTitle}</h5>

                  <p>
                    {successMessage}

                    {environmentDisplay && (
                      <>
                        {" "}
                        <strong className="publishedRule-result-content-env">
                          {environmentDisplay}
                        </strong>
                      </>
                    )}
                  </p>
                </>
              ) : (
                <>
                  <ErrorIcon
                    fontSize="large"
                    sx={{ color: "red" }}
                  />

                  <h5>{failedTitle}</h5>

                  <p>{failedMessage}</p>

                  {failedItems.length > 0 && (
                    <div className="publishedRule-error-message">
                      {failedInfoMessage}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        {type === "result" && (
          <div className="publishedRule-info-modal-footer">
            <button
              type="button"
              className="publishedRule-btn publishedRule-btn--primary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublishStatusModal;